import { Component, OnInit, OnDestroy }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { UserSession } from '../../shared/user-session';

import {RegionalReviewService} from './regional-review.service';


import * as _ from 'lodash';

@Component({
    //templateUrl: 'app/system-management/towers-tracons-import/towers-tracons-import.component.html',
    template: require('./regional-review.component.html'),
    //styles: [require('./tracon-model.css')],
    directives: [ROUTER_DIRECTIVES],
    providers:[RegionalReviewService]
})
export class RegionalReviewComponent implements OnInit {
    pageTitle: string = 'Regional Review';
    errorMessage: string;
    private sub: any;
    constructor(private route: ActivatedRoute,
                private router: Router){}
 ngOnInit():void{}
}


/** WEBPACK FOOTER **
 ** ./app/system-management/regional-review/regional-review.component.ts
 **/